var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { IsoLanguageCode, LearnwareInstance } from '../../learnware/LearnwareEnums';
export class AppConfig {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get app() {
        return this.parent;
    }
    get expectedLanguage() {
        switch (typeof window !== 'undefined' && this.app.appInfo.instance) {
            case LearnwareInstance.AbfragerDE:
                return IsoLanguageCode.de_DE;
            case LearnwareInstance.AbfragerAT:
                return IsoLanguageCode.de_AT;
            case LearnwareInstance.AbfragerCH:
                return IsoLanguageCode.de_CH;
            case LearnwareInstance.AbfragerES:
                return IsoLanguageCode.de_ES;
            default:
                return IsoLanguageCode.de_DE;
        }
    }
}
__decorate([
    computed
], AppConfig.prototype, "expectedLanguage", null);
